// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "0c2b080440656008f6016ec205ea33f6e445858e/static/css/" + chunkId + "." + "8ea9c403" + ".chunk.css";
};